import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  TextField,
  Grid,
  IconButton,
  Typography,
  Divider,
  InputAdornment,
  Autocomplete,
  Chip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { getGlobals } from "../../../Configs";
import { useSelector } from "react-redux";
import moment from "moment";
import CycleCustomModal from "../../../Component/Common/ReuseableComponent/CycleCustomModal";
import ItemSearchModal from "./ItemSearchModal";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  fKeyTabInput,
} from "../../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";
import { CmpDatePicker } from "../../../Component/Common/ToolBox/ToolBox";
import { exportToExcel } from "../../ItemApprove/ItemApproveRequestAction";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MasterModal from "./MasterModal";
import ItemSelectionModal from "./ItemSelectionModal";
import GCWebReport from "../../../Component/Common/ReuseableComponent/GCWebReport";

const DetailModal = ({
  open,
  closeModal = () => {},
  vMediaQuery,
  uMediaQuery,
  rowData = [],
  xMediaQuery,
}) => {
  const baseURL = getGlobals().API_BASE_URL;
  const [settingDetail, setSettingDetail] = useState([]);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const PDTUserList = useSelector(
    (state) => state.SliceDB.value.DbData.WMSPDTUserList
  );
  console.log("PDTUserList", PDTUserList);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const LocWithRights = useSelector((state) => state.SliceGRNLocation.value);
  const [itemSelectModal, setItemSelectModal] = useState(false);
  const [searchModal, setSearchModal] = useState(false);
  const [masterModal, setMasterModal] = useState(false);

  let headInitObj = {
    sheetId: rowData?.A_SheetId || 0,
    dateValue: rowData?.A_Date || new Date(),
    refNo: rowData?.A_RefNo || "",
    narration: rowData?.A_Narration || "",
    location: rowData?.A_Loc || LocWithRights[0]?.UID,
    selectedUser: rowData?.A_UserCd || "",
    status: rowData?.A_Status,
    count: rowData?.A_Count_Status,
  };
  const [headObj, setHeadObj] = useState(headInitObj);

  let detailInitObj = {
    itemCode: "",
    itemName: "",
  };

  const handleHeadChange = (field, value) => {
    setHeadObj((prev) => ({
      ...prev,
      [field]: value,
    }));
    setHeadErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const [detailObj, setDetailObj] = useState(detailInitObj);

  const handleDetailChange = (field, value, event = null) => {
    setDetailObj((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  let initHeadError = {
    sheetId: "",
    dateValue: "",
    location: "",
    refNo: "",
    selectedUser: "",
  };
  const [headErrors, setHeadErrors] = useState(initHeadError);

  let initError = {
    itemCode: "",
    itemName: "",
  };
  const [errors, setErrors] = useState(initError);

  const fValidationHead = () => {
    let isValid = true;
    const newError = {
      sheetId: "",
      dateValue: "",
      location: "",
      refNo: "",
      selectedUser: "",
    };
    if (
      headObj?.sheetId === "" ||
      headObj?.sheetId == undefined ||
      headObj?.sheetId === null
    ) {
      newError.sheetId = "TransId is required.";
      isValid = false;
    }
    if (
      !headObj?.dateValue ||
      headObj?.dateValue == undefined ||
      headObj?.dateValue === null ||
      headObj?.dateValue === "Invalid date"
    ) {
      newError.dateValue = "Date is required.";
      isValid = false;
    }
    if (
      headObj?.refNo == "" ||
      headObj?.refNo == undefined ||
      headObj?.refNo === null
    ) {
      newError.refNo = "RefNo is required.";
      fAlertToast("FAILED", "RefNo is required.");
      isValid = false;
    }
    if (
      headObj?.location == "" ||
      headObj?.location == undefined ||
      headObj?.location === null
    ) {
      newError.location = "Location is required.";
      isValid = false;
    }
    if (
      headObj?.selectedUser == "" ||
      headObj?.selectedUser == undefined ||
      headObj?.selectedUser === null
    ) {
      newError.selectedUser = "User is required.";
      fAlertToast("FAILED", "User is required.");
      isValid = false;
    }
    if (
      headObj?.status == "" ||
      headObj?.status == undefined ||
      headObj?.status === null
    ) {
      newError.status = "status is required.";
      isValid = false;
    }

    setHeadErrors((prevError) => ({
      ...prevError,
      ...newError,
    }));

    if (!isValid) {
      const firstInvalidField = Object.keys(newError).find(
        (key) => newError[key]
      );
      document.querySelector(`[name="${firstInvalidField}"]`)?.focus();
    }

    return isValid;
  };

  const fValidationDetail = () => {
    let isValid = true;

    const newError = {
      itemCode: "",
      itemName: "",
    };
    if (
      detailObj?.itemCode === "" ||
      detailObj?.itemCode == undefined ||
      detailObj?.itemCode === null
    ) {
      newError.itemCode = "Item Code is required.";
      isValid = false;
    }
    if (
      detailObj?.itemName === "" ||
      detailObj?.itemName == undefined ||
      detailObj?.itemName === null
    ) {
      newError.itemName = "Item Name is required.";
      isValid = false;
    }

    setErrors((prevError) => ({
      ...prevError,
      ...newError,
    }));

    // Focus on the first invalid field
    if (!isValid) {
      document.getElementById("ItemName")?.focus();
    }

    return isValid;
  };

  const handleRowClick = (row) => {
    setDetailObj((prev) => ({
      ...prev,
      itemCode: row?.B_ItmCd || "",
      itemName: row?.ItemName || "",
    }));
    setErrors(initError);
    setTimeout(() => {
      document.getElementsByName("itemName")[0].focus();
    }, 500);
  };

  useEffect(() => {
    if (open) {
      getRowApi();
      // getUserList(headObj?.location);
    }
    if (headObj?.sheetId == 0) {
      setTimeout(() => {
        document.getElementsByName("dateValue")[0]?.focus();
      }, 200);
    } else {
      setTimeout(() => {
        document.getElementsByName("itemName")[0]?.focus();
      }, 500);
    }
  }, [open, headObj?.sheetId, headObj?.location]);

  const getRowApi = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}physicalstock/WMPOIPT00B_Details_Getrow`,
        fcheck_null_undefine_replace_empty({
          B_SheetId: headObj?.sheetId,
        })
      );

      if (response?.data) {
        let GridID = response?.data?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setSettingDetail(GridID);
        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
    }
  };
  // const getUserList = async (location) => {
  //   let loader = document?.getElementById("loader");
  //   loader.style.display = "flex";
  //   try {
  //     const response = await axios.post(
  //       `${baseURL}cyclicCount/PDTUserList`,
  //       fcheck_null_undefine_replace_empty({
  //         P_location: location,
  //       })
  //     );

  //     if (response?.status === 200) {
  //       const fetchedUsers = response?.data?.recordset || [];

  //       setUserList(fetchedUsers);
  //       if (fetchedUsers.length > 0) {
  //         // setHeadObj((prev) => ({
  //         //   ...prev,
  //         //   selectedUser: fetchedUsers[0]?.UId,
  //         // }));
  //         setHeadErrors((prev) => ({ ...prev, selectedUser: "" }));
  //       }
  //       loader.style.display = "none";
  //     }
  //     // setTimeout(() => {
  //     //   document.getElementsByName("refNo")[0].focus();
  //     // }, 500);
  //   } catch (error) {
  //     loader.style.display = "none";
  //   }
  // };

  const saveApi = async (iDetail = [], deleteInsert = "") => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}physicalstock/WMPOIPT00A_WMPOIPT00B_Update`,
        fcheck_null_undefine_replace_empty({
          A_SheetId: headObj?.sheetId,
          A_RefNo: headObj?.refNo,
          A_Date: moment(headObj?.dateValue).format("MM/DD/YYYY"),
          A_Loc: headObj?.location,
          // B_ItmCd: detailObj?.itemCode,
          A_UserCd: headObj?.selectedUser,
          A_Status: rowData?.A_Status,
          A_TransUser: vRdxuserInfo?.UserID,
          DeleteInsert: deleteInsert,
          Items: iDetail,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        const newSheetId = response?.data?.recordset[0]?.A_SheetId;
        if (response?.data?.recordset?.length > 0) {
          setHeadObj((prev) => ({
            ...prev,
            sheetId: newSheetId,
          }));
        }
        fAlertToast("SUCCESS", "Line items saved successfully");
        loader.style.display = "none";
        fNewDetail();
        setItemSelectModal(false);
        setMasterModal(false);
      }
    } catch (error) {
      loader.style.display = "none";
      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurredddddd.";
      fAlertToast("FAILED", `${errorMessage}`);
    }
  };

  const postApi = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}physicalstock/WMPOIPT00A_POST`,
        fcheck_null_undefine_replace_empty({
          SheetId: headObj?.sheetId,
          UserCd: vRdxuserInfo?.UserID,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Transaction posted successfully");
        setHeadObj((prev) => ({
          ...prev,
          status: "Post",
        }));
        loader.style.display = "none";
        fNewDetail();
        closeModal();
      }
    } catch (error) {
      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `${errorMessage}`);
      loader.style.display = "none";
    }
  };
  const deleteRowApi = async (row) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}physicalstock/WMPOIPT00A_WMPOIPT00B_Delete`,
        fcheck_null_undefine_replace_empty({
          SheetId: headObj?.sheetId,
          UserCd: vRdxuserInfo?.UserID,
          ItemCode: row.B_ItmCd,
        })
      );

      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Line items deleted successfully");
        fNewDetail();
        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
    }
  };
  const fSave = (arr) => {
    setErrors(initError);
    setHeadErrors(initHeadError);
    const isHeadValid = fValidationHead();
    if (!isHeadValid) return;

    const isDetailValid = fValidationDetail();
    if (!isDetailValid) return;

    saveApi(
      [
        {
          B_ItmCd: detailObj?.itemCode,
          // P_B_CancelledQty: 0,
          // P_B_VoidQty: 0,
          // P_B_ReturnQt: 0,
          // P_B_AdjustQty: 0,
          // P_B_PurchaseReturnQty: 0,
          // P_B_SrQty: 0,
        },
      ],
      "N"
    );
  };

  const fPost = () => {
    setErrors(initError);
    setHeadErrors(initHeadError);

    let validation = fValidationHead();
    if (!validation) return;

    if (settingDetail?.length == 0) {
      fAlertToast("INFO", "Add atleast one line item");
      return;
    }
    confirmAlert({
      title: "Approve",
      message: "Are you want to Approve?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            postApi();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };
  const fDelete = (row) => {
    confirmAlert({
      title: "Delete",
      message: "Are you want to delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            deleteRowApi(row);

            setTimeout(() => {
              document.getElementsByName("itemName")[0].focus();
            }, 600);
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };
  const fReverse = () => {
    confirmAlert({
      title: "Reverse",
      message: "Are you want to Reverse?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            ReverseApi();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };
  const ReverseApi = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}physicalstock/WMPOIPT00A_Reverse`,
        fcheck_null_undefine_replace_empty({
          SheetId: headObj?.sheetId,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Transaction Reversed successfully");
        setHeadObj((prev) => ({
          ...prev,
          status: "ENTER",
        }));
        loader.style.display = "none";
        fNewDetail();
        closeModal();
      }
    } catch (error) {
      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `${errorMessage}`);
      loader.style.display = "none";
    }
  };
  const searchExactItemaAPI = async (location) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}RpDesign/searchExactItem`,
        fcheck_null_undefine_replace_empty({
          anyData: detailObj?.itemName,
          transType: "F",
          report: "Y",
          loc: headObj?.location,
        })
      );

      console.log("API Response:", response?.data);

      console.log("Fetched Items:", response?.data?.ResultSet[0]);

      if (response?.data?.ResultSet?.length == 1) {
        setDetailObj((prev) => ({
          ...prev,
          itemCode: response?.data?.ResultSet[0]?.ItmCd || "",
          itemName: response?.data?.ResultSet[0]?.Name1 || "",
        }));
        console.log("Setting Item:", response?.data?.ResultSet[0]);
        console.log("Updated DetailObj:", detailObj);
      } else if (response?.data?.ResultSet?.length == 0) {
        setSearchModal(true);

        setTimeout(() => {
          document.getElementById("anyDataDes")?.focus();
        }, 1000);
      } else {
        setDetailObj((prev) => ({
          ...prev,
          itemCode: "",
          itemName: "",
        }));
        fAlertToast("FAILED", "No matching item found.");
      }
      loader.style.display = "none";
    } catch (error) {
      loader.style.display = "none";
      setErrors(initError);
      console.error("Error fetching item data:", error);
      fAlertToast("FAILED", "An error occurred while searching.");
    }
  };
  const tapItemSelectionModal = () => {
    setHeadErrors(initHeadError);

    let validation = fValidationHead();
    if (!validation) return;
    setItemSelectModal(true);
    setTimeout(() => {
      document.getElementsByName("fromDate")[0].focus();
    }, 500);
  };
  const fOpenItemSearchModal = (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      searchExactItemaAPI();
    }
    if (e?.key === "Backspace") {
      setDetailObj((prev) => ({
        ...prev,
        itemCode: "",
      }));
    }
  };

  const handleAddNew = () => {
    if (detailObj?.itemName === "") {
      fHead();
      setTimeout(() => {
        document.getElementsByName("dateValue")[0].focus();
      }, 500);
    } else {
      fNewDetail();
    }
  };

  const fNewDetail = async () => {
    setDetailObj((prev) => ({
      ...prev,
      itemCode: "",
      itemName: "",
    }));
    setErrors(initError);
    await getRowApi();
    setTimeout(() => {
      document.getElementsByName("itemName")[0].focus();
    }, 500);
  };

  const fHead = () => {
    setHeadObj((prev) => ({
      ...prev,
      sheetId: 0,
      dateValue: new Date(),
      refNo: "",
      narration: "",
      location: LocWithRights[0]?.UID,
      selectedUser: PDTUserList.length > 0 ? PDTUserList[0]?.UId : {},
      status: "ENTER",
    }));
    setHeadErrors(initHeadError);
    setTimeout(() => {
      document.getElementsByName("dateValue")[0].focus();
    }, 500);
  };
  const fExport = () => {
    exportToExcel(settingDetail, "StockSettingDetail", "StockSettingDetail");
  };

  const tapMasterModal = () => {
    setHeadErrors(initHeadError);

    let validation = fValidationHead();
    if (!validation) return;
    setMasterModal(true);
    setTimeout(() => {
      document.getElementsByName("mainGrp")[0]?.focus();
    }, 600);
  };

  return (
    <Box className="stock-detail">
      <Grid
        container
        columnSpacing={{ xs: 1.1, sm: 1, md: 2, lg: 2 }}
        rowSpacing={1}
        mt={vMediaQuery ? 1 : 0}
      >
        <Grid item xs={6} sm={2.5} md={2.5} lg={1.5}>
          <Typography>Trans ID</Typography>

          <TextField fullWidth value={headObj?.sheetId} disabled />
        </Grid>
        <Grid item xs={6} sm={3.5} md={3} lg={2}>
          <Typography>Trans Date</Typography>
          <CmpDatePicker
            xValue={headObj?.dateValue}
            xOnChange={(newValue) =>
              setHeadObj((obj) => ({
                ...obj,
                dateValue: newValue.$d,
              }))
            }
            xName={"dateValue"}
            xError={false}
            xErrorMessage={false}
            xDisable={settingDetail?.length > 0}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6.5} lg={3.5}>
          <Typography>Location</Typography>
          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={LocWithRights}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            }
            value={
              LocWithRights?.find((loc) => loc.UID === headObj?.location) ||
              null
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setHeadObj((prev) => ({
                  ...prev,
                  location: newValue,
                }));
              } else if (newValue) {
                setHeadObj((prev) => ({
                  ...prev,
                  location: newValue.UID,
                }));
              }
              setHeadErrors((prev) => ({
                ...prev,
                location: "",
              }));
            }}
            onInputChange={(event, newValue, reason) => {
              if (reason === "clear" || newValue === "") {
                setHeadObj((prev) => ({
                  ...prev,
                  location: "",
                }));
              }
            }}
            onKeyUp={(e) => {
              fKeyTabInput(e, "selectedUser");
            }}
            disabled={settingDetail?.length > 0}
            renderInput={(params) => (
              <TextField
                {...params}
                type="search"
                error={headErrors?.location === "" ? false : true}
                helperText={headErrors?.location}
              />
            )}
          />
        </Grid>

        <Grid item xs={6} sm={5} md={4} lg={3.5}>
          <Typography>User</Typography>

          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            name="selectedUser"
            disableClearable
            options={PDTUserList} // Use full objects
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            } // Support free text input
            value={
              PDTUserList?.find((loc) => loc.UId === headObj?.selectedUser) ||
              ""
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setHeadObj((prev) => ({
                  ...prev,
                  selectedUser: newValue, // Store typed value
                }));
              } else if (newValue) {
                setHeadObj((prev) => ({
                  ...prev,
                  selectedUser: newValue.UId, // Store UID when selecting from dropdown
                }));
              }
              setHeadErrors((prev) => ({
                ...prev,
                selectedUser: "",
              }));
            }}
            onInputChange={(event, newValue, reason) => {
              if (reason === "clear" || newValue === "") {
                setHeadObj((prev) => ({
                  ...prev,
                  selectedUser: "",
                }));
              }
            }}
            onKeyUp={(e) => {
              fKeyTabInput(e, "refNo");
            }}
            disabled={settingDetail?.length > 0}
            renderInput={(params) => (
              <TextField
                {...params}
                error={headErrors?.selectedUser === "" ? false : true}
                helperText={headErrors?.selectedUser}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    type: "search",
                  },
                }}
              />
            )}
          />
          {/* <Autocomplete
            multiple
            freeSolo
            id="multi-select-user"
            name="selectedUser"
            disableClearable
            options={PDTUserList} // Use full objects
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            } // Support free text input
            value={
              PDTUserList?.filter((user) =>
                headObj?.selectedUser?.includes(user.UId)
              ) || []
            } // Ensure array is used for selection
            onChange={(event, newValue) => {
              setHeadObj((prev) => ({
                ...prev,
                selectedUser: newValue.map((user) =>
                  typeof user === "string" ? user : user.UId
                ), // Store multiple UIds
              }));
              setHeadErrors((prev) => ({
                ...prev,
                selectedUser: "",
              }));
            }}
            onInputChange={(event, newValue, reason) => {
              if (reason === "clear" || newValue === "") {
                setHeadObj((prev) => ({
                  ...prev,
                  selectedUser: [],
                }));
              }
            }}
            onKeyUp={(e) => {
              fKeyTabInput(e, "refNo");
            }}
            disabled={settingDetail?.length > 0}
            renderInput={(params) => (
              <TextField
                {...params}
                error={headErrors?.selectedUser !== ""}
                helperText={headErrors?.selectedUser}
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  fontSize: "12px",
                  "& .MuiOutlinedInput-root": {
                    maxHeight: "32px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                  },
                }}
              />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={index}
                  label={typeof option === "string" ? option : option.Name1}
                  {...getTagProps({ index })}
                  size="small" // Reduce chip size
                  sx={{ fontSize: "0.75rem", height: 20 }} // Adjust chip styling
                />
              ))
            }
          /> */}
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={1.5}>
          <Typography>RefNo</Typography>

          <TextField
            fullWidth
            value={headObj?.refNo}
            name="refNo"
            onChange={(event) => handleHeadChange("refNo", event.target.value)}
            error={headErrors?.refNo === "" ? false : true}
            helperText={headErrors?.refNo}
            disabled={false}
            onKeyUp={(e) => {
              fKeyTabInput(e, "narration");
            }}
            autoComplete="off"
          />
        </Grid>
        {/* <Grid item xs={9} sm={5} md={6} lg={6.5}>
          <Typography>Narration</Typography>
          <TextField
            fullWidth
            value={headObj?.narration}
            name="narration"
            onChange={(event) =>
              handleHeadChange("narration", event.target.value)
            }
            onKeyUp={(e) => {
              fKeyTabInput(e, "itemName");
            }}
            disabled={settingDetail?.length > 0}
            autoComplete="off"
          />
        </Grid> */}
        <Grid
          item
          // xs={12}
          // sm={12}
          // md={12}
          // lg={5.5}
          textAlign={vMediaQuery ? "center" : "right"}
        >
          <Button
            variant="contained"
            sx={{
              height: "30px",
              mt: vMediaQuery || xMediaQuery ? 0 : 2,
              mr: 1,
              textTransform: "capitalize",
            }}
            onClick={handleAddNew}
          >
            New
          </Button>
          <Button
            variant="contained"
            disabled={(headObj?.status).toUpperCase() !== "ENTER"} // Disable if status is not 'ENTER'
            sx={{
              height: "30px",
              mt: vMediaQuery || xMediaQuery ? 0 : 2,
              mr: 1,
              textTransform: "capitalize",
            }}
            onClick={fSave}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              height: "30px",
              mt: vMediaQuery || xMediaQuery ? 0 : 2,
              mr: 1,
              textTransform: "capitalize",
            }}
            disabled={
              (headObj?.status).toUpperCase() !== "ENTER" ||
              headObj?.sheetId == 0 ||
              settingDetail?.length == 0
            }
            onClick={() => {
              if (detailObj?.itemName !== "") {
                fAlertToast("FAILED", "save curent line item");
              } else {
                fPost();
              }
            }}
          >
            Post
          </Button>

          <Button
            variant="contained"
            color="primary"
            // disabled={(formData?.A_Status).toUpperCase() !== "ENTER"} // Disable if status is not 'ENTER'
            sx={{
              height: "30px",
              mr: 1,
              mt: uMediaQuery ? 1 : vMediaQuery || xMediaQuery ? 0 : 2,
              textTransform: "capitalize",
            }}
            onClick={tapItemSelectionModal}
            disabled={(headObj?.status).toUpperCase() !== "ENTER"}
          >
            Excel Import
          </Button>
          <Button
            variant="contained"
            color="primary"
            // disabled={(formData?.A_Status).toUpperCase() !== "ENTER"} // Disable if status is not 'ENTER'
            sx={{
              height: "30px",
              mr: 1,
              mt: uMediaQuery ? 1 : vMediaQuery || xMediaQuery ? 0 : 2,
              textTransform: "capitalize",
            }}
            onClick={tapMasterModal}
            disabled={(headObj?.status).toUpperCase() !== "ENTER"}
          >
            Master
          </Button>
          <Button
            variant="contained"
            color="primary"
            // disabled={(formData?.A_Status).toUpperCase() !== "ENTER"} // Disable if status is not 'ENTER'
            sx={{
              height: "30px",
              mr: 1,
              mt: uMediaQuery ? 1 : vMediaQuery || xMediaQuery ? 0 : 2,
              textTransform: "capitalize",
            }}
            onClick={() => {
              // /WMS/POPhysicalStock?Sheet=4000100001
              let urlPrint =
                vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val +
                "WMS/POPhysicalStock?Sheet=" +
                headObj?.sheetId;
              setWebReportUrlModal(urlPrint);
              fWebReport();
              console.log(urlPrint);
            }}
          >
            Print
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              height: "30px",
              mt: vMediaQuery || xMediaQuery ? 0 : 2,
              mr: 1,
              textTransform: "capitalize",
            }}
            disabled={
              (headObj?.status).toUpperCase() === "ENTER" ||
              (headObj?.count).toUpperCase() !== "ENTER"
            }
            onClick={() => {
              fReverse();
            }}
          >
            Reverse
          </Button>
        </Grid>
      </Grid>
      <Divider sx={{ mt: xMediaQuery ? 1.5 : 2 }} />
      <Box mt={vMediaQuery ? 1 : xMediaQuery ? 2 : 4}>
        <Grid container spacing={{ xs: 0.5, sm: 1, md: 2, lg: 3 }}>
          <Grid
            item
            xs={4}
            sm={3}
            md={2}
            mt={vMediaQuery ? 1.5 : xMediaQuery ? 0 : 0}
          >
            <TextField
              label="Item Code"
              value={detailObj?.itemCode}
              onChange={(event) =>
                handleDetailChange("itemCode", event.target.value, event)
              }
              fullWidth
              error={errors?.itemCode === "" ? false : true}
              helperText={errors?.itemCode}
              disabled={true}
              autoComplete="off"
            />
          </Grid>
          <Grid
            item
            xs={8}
            sm={9}
            md={10}
            mt={vMediaQuery ? 1.5 : xMediaQuery ? 0 : 0}
          >
            <TextField
              sx={{
                "& .MuiOutlinedInput-input": {
                  padding: "5.5px 10px !important",
                },
              }}
              label="Item Name"
              value={detailObj?.itemName}
              onChange={(event) =>
                handleDetailChange("itemName", event.target.value)
              }
              name={"itemName"}
              fullWidth
              error={errors?.itemName === "" ? false : true}
              helperText={errors?.itemName}
              onKeyUp={fOpenItemSearchModal}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={fOpenItemSearchModal}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            mt: 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: vMediaQuery ? "65vh" : "50vh",
            width: "100%",
          }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            components={{
              Toolbar: GridToolbar,
            }}
            rows={settingDetail ? settingDetail : ""}
            getRowId={(v) => v.id}
            columns={[
              {
                field: "B_ItmCd",
                headerName: "Item Code",
                width: 100,
              },
              {
                field: "ItemName",
                headerName: "Item Name",
                width: xMediaQuery ? 250 : 0,
                flex: xMediaQuery ? 0 : 2,
              },
              // {
              //   field: "B_SheetId",
              //   headerName: "Sheet ID",
              //   width: xMediaQuery ? 100 : 110,
              // },
              {
                field: "Action",
                headerName: "Action",
                width: 60,
                sortable: false,

                renderCell: (params) => (
                  <IconButton
                    color="error"
                    size="small"
                    onClick={(event) => {
                      event.stopPropagation(); // Prevent row click when clicking delete
                      fDelete(params.row);
                      // setDeleteUser(item);
                    }}
                    disabled={headObj?.status === "POST"}
                  >
                    <DeleteIcon />
                  </IconButton>
                ),
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              ".MuiCheckbox-root": { padding: "4px !important" },
              ".MuiDataGrid-columnHeaderCheckbox": {
                width: vMediaQuery ? "30px !important" : "50px",
                minWidth: vMediaQuery ? "30px !important" : "50px",
              },
              ".MuiDataGrid-cellCheckbox": {
                minWidth: vMediaQuery ? "30px !important" : "50px",
                maxWidth: vMediaQuery ? "30px !important" : "50px",
              },
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
            onRowClick={(params) => handleRowClick(params.row)}
          />
        </Box>
      </Box>

      <CycleCustomModal
        open={searchModal}
        onClose={() => setSearchModal(false)}
        vMediaQuery={vMediaQuery}
        xMediaQuery={xMediaQuery}
        title="Item Search"
      >
        <ItemSearchModal
          open={searchModal}
          xMediaQuery={xMediaQuery}
          handleClose={() => setSearchModal(false)}
          handleRowClick={(item) => {
            setDetailObj((prev) => ({
              ...prev,
              itemCode: item.ItmCd,
              itemName: item.Name1,
            }));
            setErrors(initError);
            setSearchModal(false);
          }}
          location={headObj?.location}
          anyDataItemName={detailObj?.itemName}
        />
      </CycleCustomModal>
      <CycleCustomModal
        open={itemSelectModal}
        onClose={() => {
          setItemSelectModal(false);
          setTimeout(() => {
            document.getElementsByName("itemName")[0].focus();
          }, 500);
        }}
        vMediaQuery={vMediaQuery}
        xMediaQuery={xMediaQuery}
        title="Item Selection"
      >
        <ItemSelectionModal
          open={itemSelectModal}
          xMediaQuery={xMediaQuery}
          vMediaQuery={vMediaQuery}
          handleClose={() => setItemSelectModal(false)}
          onClickSave={(arr, deleteInsert) => {
            setErrors(initError);
            setHeadErrors(initHeadError);
            const isHeadValid = fValidationHead();
            if (!isHeadValid) {
              setItemSelectModal(false);
              return;
            }

            let payload = arr.find((option, index) => {
              return (
                option.B_ItmCd == "" ||
                option.B_ItmCd == null ||
                option.B_ItmCd == undefined
              );
            });

            if (!!payload && Object?.keys(payload)?.length) {
              fAlertToast("FAILED", "No Item code should be empty");
              return;
            } else {
              confirmAlert({
                title: "Save",
                message: "Are you sure you want to save?",
                buttons: [
                  {
                    className: "alertBtn",
                    label: "Yes",
                    onClick: () => {
                      saveApi(arr, deleteInsert);
                      setTimeout(() => {
                        document.getElementsByName("itemName")[0].focus();
                      }, 600);
                    },
                  },
                  {
                    className: "alertBtn",
                    label: "No",
                    onClick: () => "",
                  },
                ],
              });
            }
          }}
          fNewDetail={fNewDetail}
          setHeadObj={setHeadObj}
          headObj={headObj}
        />
      </CycleCustomModal>
      <CycleCustomModal
        open={masterModal}
        onClose={() => {
          setMasterModal(false);
          setTimeout(() => {
            document.getElementsByName("itemName")[0].focus();
          }, 500);
        }}
        vMediaQuery={vMediaQuery}
        xMediaQuery={xMediaQuery}
        title="Item Master"
      >
        <MasterModal
          open={masterModal}
          vMediaQuery={vMediaQuery}
          xMediaQuery={xMediaQuery}
          settingDetail={settingDetail}
          loc={headObj?.location}
          handleClose={() => setMasterModal(false)}
          onClickSave={(arr, deleteInsert) => {
            setErrors(initError);
            setHeadErrors(initHeadError);
            const isHeadValid = fValidationHead();
            if (!isHeadValid) {
              setMasterModal(false);
              return;
            }

            let payload = arr.find((option, index) => {
              return (
                option.B_ItmCd == "" ||
                option.B_ItmCd == null ||
                option.B_ItmCd == undefined
              );
            });

            if (!!payload && Object?.keys(payload)?.length) {
              fAlertToast("FAILED", "No Item code should be empty");
              return;
            } else {
              confirmAlert({
                title: "Save",
                message: "Are you sure you want to save?",
                buttons: [
                  {
                    className: "alertBtn",
                    label: "Yes",
                    onClick: () => {
                      saveApi(arr, deleteInsert);
                      setTimeout(() => {
                        document.getElementsByName("itemName")[0].focus();
                      }, 600);
                    },
                  },
                  {
                    className: "alertBtn",
                    label: "No",
                    onClick: () => "",
                  },
                ],
              });
            }
          }}
        />
      </CycleCustomModal>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </Box>
  );
};

export default DetailModal;
